module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.exportGenesCSV
    }
  }, [_c('v-icon', [_vm._v("save")]), _vm._v("   Export genes as CSV")], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "summaryDataTableId"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "name",
      "search": _vm.search,
      "no-data-text": "No Genes Available Currently",
      "custom-filter": _vm.filterItemsOnSearch
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.all,
            "indeterminate": props.indeterminate
          },
          nativeOn: {
            "click": function($event) {
              return _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '', header.visibility, header.class, header.width],
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          key: props.item.name,
          attrs: {
            "active": props.selected
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.SummaryIndex))]), _vm._v(" "), _c('td', [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "600",
            "margin-top": "2px"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (props.item.isAssociatedGene === true) ? _c('span', [_c('v-icon', {
          staticStyle: {
            "font-size": "20px"
          },
          attrs: {
            "color": "blue darken-2"
          }
        }, [_vm._v("verified_user")])], 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('center', [(props.item.isImportedGenes) ? _c('span', [_c('v-icon', {
          staticStyle: {
            "color": "#455A64"
          }
        }, [_vm._v("check_circle_outline")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('td', [_c('center', _vm._l((props.item.sourceGTR), function(x) {
          return _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(x)
            }
          })])
        }))], 1), _vm._v(" "), _c('td', [_c('center', _vm._l((props.item.sourcePheno), function(x) {
          return _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(x)
            }
          })])
        }))], 1), _vm._v(" "), _c('td', [_c('v-menu', {
          staticStyle: {
            "color": "black"
          },
          attrs: {
            "bottom": "",
            "offset-y": ""
          }
        }, [_c('v-icon', {
          staticStyle: {
            "padding-right": "4px"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("more_vert")]), _vm._v(" "), _c('v-card', [_c('div', {
          staticClass: "conditionsBox"
        }, [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', {
          staticStyle: {
            "font-size": "18px"
          }
        }, [_vm._v(" Gene Resource Links  "), _c('i', [_vm._v("( " + _vm._s(props.item.name) + " )")])])])], 1)], 1), _vm._v(" "), _c('v-divider', {
          staticClass: "Rightbar_card_divider"
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("MedGen")]), _c('a', {
          attrs: {
            "href": props.item.medGenSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                           MedGen organizes information related to human medical genetics, such as attributes of conditions with a genetic contribution.\n                        ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("OMIM")]), _c('a', {
          attrs: {
            "href": props.item.omimSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                          OMIM is a comprehensive, authoritative compendium of human genes and genetic phenotypes\n                        ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("GeneCards")]), _c('a', {
          attrs: {
            "href": props.item.geneCardsSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                         GeneCards is a searchable, integrative database that provides comprehensive, user-friendly information on all annotated and predicted human genes.\n                       ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("Genetics Home Reference")]), _c('a', {
          attrs: {
            "href": props.item.ghrSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                        Genetics Home Reference provides consumer-friendly information about the effects of genetic variation on human health.\n                      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("ClinGen")]), _c('a', {
          attrs: {
            "href": props.item.clinGenLink,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                       The Clinical Genome Resource (ClinGen) consortium curates genes and regions of the genome to assess whether there is evidence to support that these genes/regions are dosage sensitive and should be targeted on a cytogenomic array                       ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("Gene ID "), _c('i', [_vm._v(" ( " + _vm._s(props.item.geneId) + " )")])]), _c('a', {
          attrs: {
            "href": props.item.geneIdLink,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('br')], 1)], 1)])], 1)], 1)])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('template', {
    slot: "footer"
  })], 2)], 1), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74db9684","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/SummaryDataTable.vue
// module id = 514
// module chunks = 0